import { render, staticRenderFns } from "./PaymentChannelPicker.vue?vue&type=template&id=1c6b1414&scoped=true&"
import script from "./PaymentChannelPicker.vue?vue&type=script&lang=js&"
export * from "./PaymentChannelPicker.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChannelPicker.vue?vue&type=style&index=0&id=1c6b1414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b1414",
  null
  
)

export default component.exports